import { Component, ViewEncapsulation } from '@angular/core';
import { DumbInvoice } from './DTOs/dumb-invoice';
import { MemberInvoicesService } from './member-invoices.service';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { ToastNotificationService } from '../../core/toast-notification.service';
import { UIBlockingService } from '../../core/ui-blocking.service';
import { Observable, merge } from 'rxjs';
import { MemberInvoicesDtRetInfo } from './DTOs/member-invoices-dt-ret-info';
import { GetInvoicesRequest } from './DTOs/get-invoices-request';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-member-invoices',
  templateUrl: './member-invoices.component.html',
  providers: [UIBlockingService, NgbDropdown],
  encapsulation: ViewEncapsulation.None
})

export class MemberInvoicesComponent {
  constructor(private invoiceService: MemberInvoicesService
    , private blockUI: UIBlockingService
    , private notificationService: ToastNotificationService) {

  }
  totalPayableInvoices: number = 0;
  runningTotal: number = 0;
  allSelected: boolean = false;
  selectedInvoices: number[] = [];
  memberInvoices: DumbInvoice[] = [];
  totalAdmin = 0;
  filteredAdmin = 0;
  pageNum = 1;
  itemsPerPage = 10;
  searchText = "";
  statusSearch = { display: "All", value: -1 };
  sortType = 2;
  keywordSearches: string[] = [];
  filtersChanged = true;
  initialLoad = true;

  get selectedInvoicesCount() { return this.selectedInvoices.length }
  get currentPageNum() { return this.pageNum };
  set currentPageNum(page: number) {
    this.pageNum = page;
    if (!this.initialLoad)
      this.getMemberInvoices();
  }
  get invoiceIdsString() { return this.selectedInvoices.toString(); }
  get itemStart() {
    return ((this.currentPageNum - 1) * this.itemsPerPage) + 1;
  }
  get itemEnd() {
    return ((this.currentPageNum - 1) * this.itemsPerPage) + this.memberInvoices.length;
  }
  removeSearchTerm(term: string) {
    var index = this.keywordSearches.indexOf(term);
    if (index != -1) {
      this.keywordSearches.splice(index, 1);
      this.filtersChanged = true;
    }
    this.getMemberInvoices();
  }
  ngOnInit() {
    var observablesMerged = merge(this.getMemberInvoicesObservable());
    this.blockUI.start();
    observablesMerged.subscribe(
      {
        next: (data) => {
          this.memberInvoices = data.data;
          this.totalPayableInvoices = data.totalPayableInvoices;
          this.memberInvoices.forEach(invoice => {
            if (this.selectedInvoices.indexOf(invoice.id) >= 0) {
              invoice.isSelected = true;
            }
          });
          this.totalAdmin = data.recordsTotal;
          this.filteredAdmin = data.recordsFiltered;
          this.initialLoad = false;
        },
        error: (err) => {
          this.notificationService.error(err.error.message);
          this.blockUI.stop();
          console.log(err)
        },
        complete: () => {
          this.blockUI.stop();
        }
      });
  }

  getMemberInvoicesObservable(): Observable<MemberInvoicesDtRetInfo> {
    var req = this.createSearchRequest();
    return this.invoiceService
      .searchMemberInvoices(req);
  }
  getMemberInvoices() {
    this.blockUI.start();

    this.getMemberInvoicesObservable()
      .subscribe(
        {
          next: (data) => {
            this.memberInvoices = data.data;
            this.totalAdmin = data.recordsTotal;
            this.filteredAdmin = data.recordsFiltered;
          },
          error: (err) => {
            this.notificationService.error(err.error.message);
            this.blockUI.stop();
            console.log(err)
          },
          complete: () => {
            this.blockUI.stop();
          }
        });
  }
  createSearchRequest(): GetInvoicesRequest {
    var req = new GetInvoicesRequest();

    if (this.filtersChanged)
      this.pageNum = 1;

    req.PageNumber = this.pageNum - 1; //to get the 0-indexed number
    req.ItemsPerPage = this.itemsPerPage;

    req.KeywordSearches = this.keywordSearches;
    req.InvoiceSorting = this.sortType;
    req.StatusFilter = this.statusSearch.value;

    this.filtersChanged = false;

    return req;
  }
  clearSearch() {
    this.searchText = "";
    this.statusSearch = { display: "Active", value: 1 };
    this.sortType = 1;
    this.keywordSearches = [];
    this.filtersChanged = true;
  }
  changeStatusSearch(toChange: number) {
    if (this.statusSearch.value == toChange)
      return;

    this.filtersChanged = true;
    switch (toChange) {
      case -1:
        this.statusSearch = { display: "All", value: -1 };
        break;
      case 0:
        this.statusSearch = { display: "Invoiced", value: 0 };
        break;
      case 1:
        this.statusSearch = { display: "Partially Paid", value: 1 };
        break;
      case 2:
        this.statusSearch = { display: "Paid In Full", value: 2 };
        break;
      case 3:
        this.statusSearch = { display: "Past Due", value: 3 };
        break;
      case -9999:
        this.statusSearch = { display: "Cancelled", value: -9999 };
        break;
      default:
        this.statusSearch = { display: "All", value: -1 };
        break;
    }
  }
  hitSearchBtn() {
    this.searchText.trim().split(' ').forEach((term) => { if (term != '') { this.keywordSearches.push(term) } });
    this.searchText = '';
    this.filtersChanged = true;
    this.getMemberInvoices();
  }
  changeSortType(column: number) {
    switch (column) {
      case 1:
        if (this.sortType == 1)
          this.sortType = 2;
        else this.sortType = 1;
        break;
      case 2:
        if (this.sortType == 3)
          this.sortType = 4;
        else this.sortType = 3;
        break;
      case 3:
        if (this.sortType == 5)
          this.sortType = 6;
        else this.sortType = 5;
        break;
      case 4:
        if (this.sortType == 7)
          this.sortType = 8;
        else this.sortType = 7;
        break;
      case 5:
        if (this.sortType == 9)
          this.sortType = 10;
        else this.sortType = 9;
        break;
      default:
        break;
    }
    this.filtersChanged = true;
    this.getMemberInvoices();
  }

  enterSearchTerm(event: any) {
    if (event.keyCode != 13)//13 is enter, 32 is space
      return;

    this.searchText.trim().split(' ').forEach((term) => { if (term != '') { this.keywordSearches.push(term) } });
    this.searchText = '';
    this.filtersChanged = true;
    this.getMemberInvoices();
    return;
  }
  selectInvoice(invoice: DumbInvoice) {
    var invoiceInList = this.selectedInvoices.indexOf(invoice.id);
    if (invoiceInList < 0) {
      this.selectedInvoices.push(invoice.id)
      invoice.isSelected = true;
      this.runningTotal += invoice.amount;
      if (this.selectedInvoices.length == this.totalPayableInvoices)
        this.allSelected = true;
    }
    else {
      this.selectedInvoices.splice(invoiceInList, 1)
      this.runningTotal -= invoice.amount;
      invoice.isSelected = false;
      this.allSelected = false;
    }
  }

  selectAllInvoices() {
    var req = this.createSearchRequest();

    if (!this.allSelected) {
      this.allSelected = false;
      this.runningTotal = 0;
      this.selectedInvoices = [];
      this.memberInvoices.forEach(invoice => {
        invoice.isSelected = false;
      });
    }
    else {
      this.blockUI.start();
      this.invoiceService.selectAllInvoices(req).subscribe(
        {
          next: (data) => {
            data.forEach(invoice => {
              if (this.selectedInvoices.indexOf(invoice.id) == -1) {
                this.selectedInvoices.push(invoice.id);
                this.runningTotal += invoice.amount;
              }
            });
            this.memberInvoices.forEach(invoicee => {
              if (invoicee.status == 3 || invoicee.status == 0 || invoicee.status == 1)
                invoicee.isSelected = true;
            });
            this.blockUI.stop();
            this.allSelected = true;
          },
          error: (err) => {
            this.notificationService.error(err.error.message);
            this.blockUI.stop();
            console.log(err)
          },
          complete: () => {
            this.blockUI.stop();
          }
        });
    }
  }


}
